/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Last_VerifiedInputs */

const en_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last verified`)
};

const zh_hans1_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近验证`)
};

const pt_br2_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última verificação`)
};

const es_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última verificación`)
};

const fr_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière vérification`)
};

const de_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt geprüft`)
};

const ru_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последняя проверка`)
};

const it_app_endpoint_last_verified = /** @type {(inputs: App_Endpoint_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima verifica`)
};

/**
* | output |
* | --- |
* | "Last verified" |
*
* @param {App_Endpoint_Last_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_last_verified = /** @type {((inputs?: App_Endpoint_Last_VerifiedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Last_VerifiedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_last_verified(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_last_verified(inputs)
	if (locale === "es") return es_app_endpoint_last_verified(inputs)
	if (locale === "fr") return fr_app_endpoint_last_verified(inputs)
	if (locale === "de") return de_app_endpoint_last_verified(inputs)
	if (locale === "ru") return ru_app_endpoint_last_verified(inputs)
	if (locale === "it") return it_app_endpoint_last_verified(inputs)
	return en_app_endpoint_last_verified(inputs)
});